<template>
    <!-- 主要导航栏 -->

    <el-menu style="padding-left: 250px"  class="nav-main" mode="horizontal">
        <el-menu-item v-if="taobaoRoute" @click="toNewGoods" index="/newGoods/test/">淘宝数据
        </el-menu-item>
        <el-menu-item v-if="isoFilesRoute" @click="toIsoFiles" index="/iso/depa/">公司文件</el-menu-item>
        <el-menu-item v-if="adminRoute" @click="toAdmin" index="/admin/">内网后台</el-menu-item>

        <el-submenu v-if="depoRoute" class="nav-depository" index="depositorySelect">
            <template class="nav__title" slot="title">库存</template>
            <el-menu-item @click="toDepository" index="/depository/">库存动销</el-menu-item>
            <el-menu-item @click="toDepositoryInfo" index="/depository/loadfile/">库存信息更新</el-menu-item>
        </el-submenu>
        <el-menu-item v-if="orderRoute" @click="toOldOrders" index="/orderManager/">下单管理</el-menu-item>
        <el-menu-item v-if="goodRoute" @click="toGoodManager" index="/goods/">商品库</el-menu-item>
        <el-menu-item v-if="orderPlatformRoute" @click="to_orders()" index="/orders">订单控制台</el-menu-item>

        <!--        <el-menu-item @click="toDocument" index="/document">文档</el-menu-item>-->
    </el-menu>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "MainBar",
        computed: {
            ...mapGetters([
                'taobaoRoute',
                'isoFilesRoute',
                'adminRoute',
                'depoRoute',
                'orderRoute',
                'goodRoute',
                'orderPlatformRoute',
            ])
        },
        methods: {
            // 跳转到 /orders url
            to_orders() {
                const name = 'orders'
                if(this.orderPlatformRoute){  //必须有相关权限，才能进行跳转

                    this.$router.replace({name,})
                }
            },
            toIsoFiles() {
                window.location.href = "/iso/depa/";
            },
            toDocument() {
                const routerName = 'Document'
                this.$router.replace({name: routerName,})
            },

            /**
             * 跳转到淘宝数据
             */
            toNewGoods() {
                window.location.href = "/newGoods/test/";
            },

            /**
             * 进入内网后台
             */
            toAdmin() {
                window.location.href = "/admin/";
            },

            /**
             * 跳转到库存动销
             */
            toDepository() {
                window.location.href = "/depository/";
            },

            /**
             * 库存更新信息展示
             */
            toDepositoryInfo() {
                window.location.href = "/depository/loadfile/";
            },

            toOldOrders() {
                window.location.href = "/orders/";
            },

            toGoodManager() {
                window.location.href = "/goods/";
            },

        },
    }
</script>

<style scoped>
    .nav-main {
        height: 45px;
        line-height: 45px;
        background-color: #f8f8f8;

    }

    .nav-main .el-menu-item {
        height: 46px;
        line-height: 46px
    }

    .nav-main >>> .el-submenu__title {
        height: 45px;
        line-height: 45px;
    }

</style>